export enum EUPLOADDTypes {
    UPLOAD_FILES_PROCESS_START = '[uploadD] upload files process start',
    UPLOAD_FILES_PROCESS_FINISH = '[uploadD] upload files process finish',
    UPLOAD_FILE_START = '[uploadD] upload file start',
    UPLOAD_FILE_SUCCESS = '[uploadD] upload file success',
    UPLOAD_FILE_FAILED = '[uploadD] upload file failed',
    CLEAN_UPLOAD_FILES = '[uploadD] clean upload files',
    CLEAN_UPLOAD_FILE = '[uploadD] clean upload file',
}
